import find from 'lodash-es/find'
import get from 'lodash-es/get'
import isNil from 'lodash-es/isNil'
import some from 'lodash-es/some'

import type { Offer } from '@fourthwall/services/dist/models/offer'

export const filterVariantsBySize = (variants: Offer.Variant[]) =>
  variants.reduce<Offer.Variant[]>((result, variant) => {
    const size = variant.size
    const cost = variant.cost?.value

    if (!size || isNil(cost)) {
      return result
    }

    if (some(result, ['size', size])) {
      const prevSizeVariant = find(result, ['size', size])
      const prevSizeVariantCost = get(prevSizeVariant, 'cost.value')

      if (prevSizeVariantCost && (!prevSizeVariant || cost < prevSizeVariantCost)) {
        return [...result, variant]
      }

      return result
    }

    return [...result, variant]
  }, [])
